import React from "react";
import { getClientActivity } from "../../api/paidClientsService";
import useClientData from "../../hooks/useClientData";
import { LIKE_SOURCES, TAB_OPENS } from "../../utils/constants";
import { daysAgo, fmtDate, fmtDateTime, fmtDaysAgo } from "../../utils/format";
import { TabState } from "../common";

const NO_EVENTS_TEXT = "Данные появятся после обновления приложения";

const ActivityTab = ({ userId, openUserDialog, openActions }) => {
  const { data, loading, error } = useClientData(getClientActivity, userId);

  return (
    <TabState loading={loading} error={error} data={data}>
      {data && <ActivityContent data={data} openUserDialog={openUserDialog} openActions={openActions} />}
    </TabState>
  );
};

function ActivityContent({ data, openUserDialog, openActions }) {
  // от старой недели к текущей: «нед. 1» … «нед. 4»
  const bars = (data.likesByWeek || []).map((w, i) => ({
    label: `нед. ${i + 1}`,
    title: `${fmtDate(w.weekStart)} — ${fmtDate(w.weekEnd)}: ${w.likes} лайков`,
    count: w.likes || 0,
  }));
  const maxBar = Math.max(1, ...bars.map((b) => b.count));

  const sourceRows = data.likeSources || [];
  const sourceBy = Object.fromEntries(sourceRows.map((s) => [s.source, s]));
  const sourcesTotal = sourceRows.reduce((s, x) => s + (x.count || 0), 0);

  const opensBy = Object.fromEntries((data.tabOpens || []).map((t) => [t.tab, t.count]));
  const eventsAvailable = data.eventsAvailable !== false;

  return (
    <>
      <div className="pc-card">
        <h3>Входы и лайки</h3>
        <div className="pc-kv">
          <div className="k">Последний вход</div>
          <span>
            {fmtDaysAgo(daysAgo(data.lastLoginAt))}
            {data.lastLoginAt && <span className="muted small"> · {fmtDateTime(data.lastLoginAt)}</span>}
          </span>
          <div className="k">Входов за 7 / 30 дней</div>
          <span>
            <b>{data.logins7 ?? 0}</b> из 7 · <b>{data.logins30 ?? 0}</b> из 30
          </span>
          <div className="k">Лайки за подписку</div>
          <div className="pc-row">
            <b>{data.likesInPeriod ?? 0}</b>
            <button type="button" className="pc-btn sm" onClick={() => openUserDialog("likes")}>
              Открыть список лайкнутых лотов
            </button>
          </div>
          <div className="k">Подписки КТРУ / шаблоны</div>
          <div className="pc-row">
            <b>{data.ktruSubscriptions ?? 0}</b>
            <button type="button" className="pc-btn sm" onClick={() => openUserDialog("textFilters")}>
              Посмотреть фильтры и подписки КТРУ
            </button>
          </div>
          <div className="k">Действия в приложении</div>
          <div>
            <button type="button" className="pc-btn sm" onClick={openActions}>
              История действий
            </button>
          </div>
        </div>

        {bars.length ? (
          <>
            <div className="pc-bars" aria-label="Лайки по неделям">
              {bars.map((b) => (
                <div key={b.label} title={b.title} style={{ height: `${(b.count / maxBar) * 100}%` }} />
              ))}
            </div>
            <div className="pc-bars-l">
              {bars.map((b) => (
                <span key={b.label}>
                  {b.label} · <b>{b.count}</b>
                </span>
              ))}
            </div>
          </>
        ) : (
          <div className="muted small" style={{ marginTop: 10 }}>
            Лайков по неделям нет
          </div>
        )}
      </div>

      <div className="pc-card">
        <h3>Как находит лоты</h3>
        {!eventsAvailable ? (
          <div className="alert info">{NO_EVENTS_TEXT}</div>
        ) : sourcesTotal ? (
          <>
            <div className="pc-share">
              {LIKE_SOURCES.map((s) =>
                sourceBy[s.key]?.count ? (
                  <div
                    key={s.key}
                    title={`${s.label}: ${sourceBy[s.key].count}`}
                    style={{ width: `${sourceBy[s.key].pct}%`, background: s.color }}
                  />
                ) : null,
              )}
            </div>
            <div className="pc-legend">
              {LIKE_SOURCES.map((s) => (
                <span key={s.key}>
                  <i style={{ background: s.color }} />
                  {s.label} {sourceBy[s.key]?.pct ?? 0}%
                </span>
              ))}
            </div>
          </>
        ) : (
          <div className="muted">Лайков за подписку нет</div>
        )}
      </div>

      <div className="pc-card">
        <h3>Что открывает</h3>
        {!eventsAvailable ? (
          <div className="alert info">{NO_EVENTS_TEXT}</div>
        ) : (
          <table className="pc-table">
            <thead>
              <tr>
                <th>Функция</th>
                <th className="r">Открытий за подписку</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {TAB_OPENS.map((t) => (
                <tr key={t.key}>
                  <td>{t.label}</td>
                  <td className={`r ${!opensBy[t.key] ? "zero" : ""}`}>{opensBy[t.key] || 0}</td>
                  <td className="r" style={{ width: 160 }}>
                    {t.key === "ts_analysis" && (
                      <button type="button" className="pc-btn sm" onClick={() => openUserDialog("analysis")}>
                        Просмотренные ТС
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

export default ActivityTab;
